var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStorefront = function SvgStorefront(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "storefront_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#storefront_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.341 25.938a2.18 2.18 0 0 1-1.603-.657 2.18 2.18 0 0 1-.656-1.603v-9.986q-.755-.62-1.134-1.61-.378-.988-.015-2.135l1.264-4.13a2.6 2.6 0 0 1 .848-1.271q.6-.484 1.43-.484h17.063q.832 0 1.42.462.59.461.859 1.27l1.288 4.153q.363 1.147-.015 2.129a4.1 4.1 0 0 1-1.134 1.64v9.962q0 .947-.656 1.603a2.18 2.18 0 0 1-1.603.657zM17.77 12.813q1.024 0 1.54-.627.516-.626.422-1.345l-.76-4.903h-3.015v4.937q0 .789.534 1.363.534.575 1.28.575m-5.625 0q.863 0 1.4-.575.538-.574.538-1.363V5.938h-3.015l-.76 4.951q-.101.666.419 1.295t1.418.629m-5.562 0q.694 0 1.194-.485.501-.485.618-1.217l.736-5.174H6.476a.53.53 0 0 0-.325.09q-.12.09-.18.271L4.77 10.365q-.247.806.233 1.627.48.82 1.58.82m16.875 0q1.014 0 1.552-.797.54-.798.26-1.65l-1.264-4.092a.47.47 0 0 0-.18-.258.6.6 0 0 0-.325-.079h-2.591l.735 5.174q.117.732.618 1.217.5.485 1.195.485"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStorefront);
export default ForwardRef;